import { render, staticRenderFns } from "./POItemsSummary.vue?vue&type=template&id=5bacb860"
import script from "./POItemsSummary.vue?vue&type=script&lang=js"
export * from "./POItemsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports